import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto;

  p {
    cursor: pointer;
    :hover {
      color: #b8976c;
      transition: 0.2s;
    }

    svg {
      margin-right: 8px;
      vertical-align: middle;
    }
  }
`;

export const DaysContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  margin-bottom: 4px;
`;

export const FilterContent = styled.div`
  display: flex;
  margin-top: 12px;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  color: #444;

  form {
    flex-wrap: wrap;
    gap: 8px;
    display: flex;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  .title {
    flex: 0 0 30%;
  }

  .actions {
    flex: 1 1 70%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  @media (max-width: 768px) {
    .title,
    .actions {
      flex: 0 0 auto;
      width: 100%;
    }

    .actions {
      justify-content: flex-start;
      margin-top: 8px;
    }
  }
`;
